import styled from 'styled-components'

export const LittleCard = styled.div`
  min-width: 400px;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: ${props => props.theme.radius.card};
  color: ${props => props.theme.colors.text.primary};
  background: ${props => props.theme.colors.background.primary};
  border: 2px solid ${props => props.theme.colors.border.light};
  font-size: 22px;
  margin: 60px 30px;
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.medium};
  transition: all 0.3s ease;

  &:hover {
    cursor: ${({ isDraggable }) => isDraggable ? 'move' : 'default'};
    transform: scale(1.05);
    box-shadow: 0 8px 24px ${props => props.theme.colors.shadow.strong};
  }
`

export const LittleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 90%;
  height: 45%;
  font-size: 40px;
`

export const LittleFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 45%;
  font-size: ${({ size }) => {
    if (size === 'small') return '0.875rem'
    if (size === 'large') return '1.125rem'
    return '1rem'
  }};
  font-family: ${props => props.theme.typography.fontFamily};
  border-top: 1px solid ${props => props.theme.colors.border.medium};
  transition: all 0.3s ease;
`

const getSemanticBackground = (theme, tipo) => {
  const colors = {
    success: theme.colors.semantic.success,
    danger: theme.colors.semantic.danger,
    warning: theme.colors.semantic.warning,
    info: theme.colors.semantic.info,
    primary: theme.colors.semantic.primary
  }
  return colors[tipo] || theme.colors.semantic.primary
}

export const LittleToolbar = styled.div`
  position: relative;
  top: -24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${props => props.theme.radius.card};
  width: 96px;
  height: 96px;
  color: ${props => props.theme.colors.text.inverse};
  background: ${({ tipo, theme }) => getSemanticBackground(theme, tipo)};
  font-size: ${({ size }) => {
    if (size === 'small') return '0.875rem'
    if (size === 'large') return '1.125rem'
    return '1rem'
  }};
  font-family: ${props => props.theme.typography.fontFamily};
  box-shadow: 0 4px 12px ${props => props.theme.colors.shadow.medium};
  transition: all 0.3s ease;
`

export const LittleIcon = {
  color: 'white',
  width: 48,
  height: 48,
  backgroundColor: 'transparent'
}
